var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C0BA3C37-F7E8-4705-91CF-338A0C9C85BA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.67,24.5465699 C24.4403143,24.5465699 20,25.8290804 20,28.3831398 L20,30.3014248 L33.34,30.3014248 L33.34,28.3831398 C33.34,25.8290804 28.8996857,24.5465699 26.67,24.5465699 Z M22.2296857,28.1090991 C23.0300857,27.4733247 24.9643857,26.7388956 26.67,26.7388956 C28.3756143,26.7388956 30.3099143,27.4733247 31.1103143,28.1090991 L22.2296857,28.1090991 Z M26.67,22.628285 C28.5090143,22.628285 30.005,20.9073093 30.005,18.791715 C30.005,16.6761208 28.5090143,14.9551451 26.67,14.9551451 C24.8309857,14.9551451 23.335,16.6761208 23.335,18.791715 C23.335,20.9073093 24.8309857,22.628285 26.67,22.628285 Z M26.67,17.1474708 C27.4608714,17.1474708 28.0992857,17.8818999 28.0992857,18.791715 C28.0992857,19.7015302 27.4608714,20.4359593 26.67,20.4359593 C25.8791286,20.4359593 25.2407143,19.7015302 25.2407143,18.791715 C25.2407143,17.8818999 25.8791286,17.1474708 26.67,17.1474708 Z M33.3781143,24.6123397 C34.4834286,25.5331165 35.2457143,26.7608188 35.2457143,28.3831398 L35.2457143,30.3014248 L39.0571429,30.3014248 L39.0571429,28.3831398 C39.0571429,26.1688909 35.7221429,24.9083037 33.3781143,24.6123397 L33.3781143,24.6123397 Z M32.3871429,22.628285 C34.2261571,22.628285 35.7221429,20.9073093 35.7221429,18.791715 C35.7221429,16.6761208 34.2261571,14.9551451 32.3871429,14.9551451 C31.8726,14.9551451 31.3961714,15.0976463 30.9578571,15.3388021 C31.5581571,16.314387 31.9107143,17.5092045 31.9107143,18.791715 C31.9107143,20.0742256 31.5581571,21.269043 30.9578571,22.244628 C31.3961714,22.4857838 31.8726,22.628285 32.3871429,22.628285 Z",
    id: "users-path"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Users",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2-1-1-Manage-Users",
    transform: "translate(-36.000000, -162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu.group",
    transform: "translate(16.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Users",
    transform: "translate(0.000000, 54.417506)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#users-path"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icons/ic/outline-people_outline-24px",
    fill: "currentColor",
    xlinkHref: "#users-path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.dacd938c.svg";
export { ForwardRef as ReactComponent };